<template>
  <div class="validation-errors">
    <div v-for="(error, index) in errors" :key="index" class="validation-error-item">{{ error }}</div>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    showErrors: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    parentFormItemStyle() {
      if (!this.showErrors) {
        return ``;
      }
      const totalErrors = this.errors.length;
      return `margin-bottom: ${totalErrors * 22 + 11}px;`;
    }
  },
  watch: {
    parentFormItemStyle() {
      this.$emit('style', this.parentFormItemStyle);
    }
  }
};
</script>

<style lang="scss">
.validation-errors {
  display: block;
  color: #f56c6c;
  text-align: left;
  position: absolute;
  top: 100%;
  .validation-error-item {
    padding-top: 4px;
    position: relative;
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
